import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { CmsMenuService } from 'src/app/core/Services/cmsmenu.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ItemAddComponent, ItemForm } from '../../shared/item-add/item-add.component';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'cms-menu',
    templateUrl: './cms-menu.component.html',
    styleUrls: ['./cms-menu.component.scss']
})

export class CmsMenuComponent implements OnInit {

    CmsMenu: CmsMenu[];

    constructor(private _shared: SharedService, private _cmsMenu: CmsMenuService) {
        // Setting up page title
        this._shared.pageTitle = 'CMS Menu (Android/iOS)';
    }

    ngOnInit() {
        // Get menu list
        this._cmsMenu.getCmsMenu().subscribe(res => this.CmsMenu = <CmsMenu[]>res['result']);
    }

    editMenuItem(menu: CmsMenu) {


        const form: ItemForm = {
            title: 'Cmsmenu',
            submitText: 'Update',
            controls: [
                {
                    label: 'Name', name: 'menuName', placeholder: '', errorMsg: 'Please provide cms menu name.',
                    value: menu.menuName
                }
            ]
        }

        if (menu.cMSMenuID === 1) {
            form.controls.push({
                label: 'Claim Url',
                name: 'urlAddress', errorMsg: 'Plese provide url for submit a claim link', placeholder: '',
                value: menu.urlAddress
            });
        }


        let ref: MatDialogRef<ItemAddComponent> = this._shared.openModal(ItemAddComponent, form);
        ref.afterClosed().subscribe(result => {
            if (!result) { return; }
            menu.menuName = result.menuName;
            if (menu.cMSMenuID === 1) { menu.urlAddress = result.urlAddress; }

            this._cmsMenu.updateCmsMenuItem(menu).subscribe(() => {
                let index = this.CmsMenu.findIndex(m => m.cMSMenuID === menu.cMSMenuID);
                this.CmsMenu[index].menuName = result.menuName
            });
        });
    }

    updateMenuOrder(e) {
        moveItemInArray(this.CmsMenu, e.previousIndex, e.currentIndex);
        
        const order = [];
        this.CmsMenu.forEach((m, i) => {
            order.push({ cMSMenuID: m.cMSMenuID, menuPosition: (i+1) });
        });

        this._cmsMenu.updateCmsMenuOrder(order).subscribe(result => {
           // Process result 
        });
    }
}


export interface CmsMenu {
    cMSMenuID: number;
    menuName: string;
    urlAddress: string;
    menuPosition: number;
}